// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/product/product-list/product-list.scss
// module id = 512
// module chunks = 0